import { Tooltip } from '@mui/material';
import { SizingOptions } from './types';
import { useCertificationLogoStyles } from '../CertificationLogo/useCertificationLogoStyles';
import { envs } from '../../../../envs';

interface AwardsIconsProps {
  awardValue: string;
  toolTip: string;
  size?: SizingOptions;
}

const AwardsIcons = ({
  awardValue,
  toolTip,
  size = SizingOptions.MEDIUM
}: AwardsIconsProps) => {
  const { classes } = useCertificationLogoStyles({ size });

  return (
    <Tooltip
      title={toolTip}
      slotProps={{
        tooltip: {
          sx: { maxWidth: 210, textAlign: 'center', whiteSpace: 'preline' }
        }
      }}
    >
      <span className={classes.container}>
        <img
          src={
            envs.REACT_APP_COVALO_STATIC_CONTENT +
            '/rx/awards/icons/' +
            awardValue
          }
          className={classes.image}
          alt={awardValue + ' award '}
        />
      </span>
    </Tooltip>
  );
};

export default AwardsIcons;
